import React from 'react';
import { motion } from 'framer-motion';

function CustomersPanel({ data }) {
  const visibleCustomers = data?.list?.filter(customer => customer.visible) || [];

  if (visibleCustomers.length === 0) {
    return null;
  }

  return (
    <div 
      className="panel panel-white" 
      data-testid="customers-panel"
    >
      <div className="panel-content">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 heading-premium">
            Trusted Partners
          </h2>
          <p className="text-xl max-w-3xl mx-auto subheading-premium">
            Collaborating with leading organizations
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {visibleCustomers.map((customer, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, ease: "easeOut", delay: index * 0.08 }}
              className="card-premium p-8 flex items-center justify-center"
              data-testid={`customer-card-${index}`}
            >
              {customer.logo ? (
                <img
                  src={customer.logo}
                  alt={customer.name}
                  className="max-h-16 object-contain"
                />
              ) : (
                <div className="text-xl font-semibold" style={{ color: '#475569' }}>
                  {customer.name}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CustomersPanel;